// extracted by mini-css-extract-plugin
export default {"messageContainer":"MessageContainer_messageContainer__Z4oQL","fadeIn":"MessageContainer_fadeIn__BGjlP","active":"MessageContainer_active__L5kUE"};